import React from 'react';
import { ArrowRightIcon, LightbulbIcon, PencilRulerIcon, RocketIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const steps = [{
  number: '01',
  icon: LightbulbIcon,
  title: 'Me cuentas',
  text: 'Qué haces, qué sueñas y qué quieres que sienta quien te encuentre.',
  tone: 'bg-brand-500 text-white'
}, {
  number: '02',
  icon: PencilRulerIcon,
  title: 'Diseño tu dirección',
  text: 'Convierto tu esencia en una experiencia clara, visual y con intención.',
  tone: 'bg-lime text-ink'
}, {
  number: '03',
  icon: RocketIcon,
  title: 'Publicamos tu presencia',
  text: 'Tu nueva web queda lista para que empieces a compartirla con orgullo.',
  tone: 'bg-coral text-white'
}];
export function ProcessSection() {
  return <section id="como-funciona" className="w-full bg-warm py-20 sm:py-28" data-id="element-114" data-mp="180x762tcjpse">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-115" data-mp="25hm35fvm7xtv">
        <Reveal data-id="element-116" data-mp="25j5ohkw4oz2i">
          <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-brand-600" data-id="element-117" data-mp="20qck4y4knsqy">Simple, cercano y sin tecnicismos</p>
        </Reveal>
        <Reveal delay={0.05} data-id="element-118" data-mp="263fp3vjxuo29">
          <h2 className="mt-4 max-w-2xl font-display text-5xl font-extrabold leading-[0.92] text-ink sm:text-6xl" data-id="element-119" data-mp="264haasuo4qxp">
            Una buena web no tiene por qué sentirse complicada.
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-120" data-mp="1waqndse6wok4">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <Reveal key={step.number} delay={index * 0.08} data-id="element-121" data-mp="1nb3lz6lgnir2" data-mpi={index}>
                <article className={`${step.tone} flex min-h-[17rem] flex-col justify-between p-7 sm:p-8`} data-id="element-122" data-mp="1rd8fm5bwsfdp">
                  <div className="flex items-start justify-between" data-id="element-123" data-mp="1de8makdgbcb7">
                    <span className="text-sm font-extrabold tracking-[0.08em] opacity-80" data-id="element-124" data-mp="1dg1tq1vw20k9">{step.number}</span>
                    <Icon className="h-7 w-7" data-id="element-125" data-mp="37rqckf58qn9x" />
                  </div>
                  <div data-id="element-126" data-mp="37pnfjb5o7tvp">
                    <h3 className="font-display text-4xl font-extrabold leading-none" data-id="element-127" data-mp="3cqt6p4jon934">{step.title}</h3>
                    <p className="mt-3 max-w-xs text-sm font-semibold leading-relaxed opacity-90" data-id="element-128" data-mp="3b9e4sau6jliz">{step.text}</p>
                  </div>
                </article>
              </Reveal>;
        })}
        </div>

        <Reveal delay={0.18} data-id="element-129" data-mp="31aolqeqjrv15">
          <div className="mt-8 flex items-center gap-2 text-sm font-extrabold text-ink" data-id="element-130" data-mp="31bzyh41z0d4e">
            Tu idea <ArrowRightIcon className="h-4 w-4" data-id="element-131" data-mp="2wdy77vue57hu" /> una web lista para mostrar
          </div>
        </Reveal>
      </div>
    </section>;
}